import { EventCreatorMap } from '@app/analytics/models/helpers';

import accountSignupComplete from './signup-complete';
import loginSuccess from './login-success';
// import signupStep1 from './signup-step1';
// import signupStep2 from './signup-step2';

import * as UserActions from '@app/core/user/store/actions/user.actions';

const eventsMap: EventCreatorMap = {
  [UserActions.REGISTER_SUCCESS]: accountSignupComplete,
  [UserActions.LOGIN_SUCCESS]: loginSuccess
  // [UserActions.OPEN_REGISTER_POPIN]: signupStep1,
  // [UserActions.OPEN_REGISTER_FORM]: signupStep2
};

export default eventsMap;
